const state = function () {
  return {
    signupModal: false,
    signupForm: {
      email: '',
      password: '',
      confirmPassword: ''
    },
    loginForm: {
      email: '',
      password: '',
      persistLogin: false
    },
    forgotPasswordForm: {
      email: ''
    },
    changePasswordForm: {
      userID: '',
      currentPassword: '',
      password: '',
      confirmPassword: ''
    },
    user: null,
    authenticating: false,
    redirectUrl: null
  }
}

export default {
  ...state()
}

export const initialState = state()
